import { EntityType } from '@/plugins/cad/module/CADModule/model/common/constant'
import type { IPoint } from '@/plugins/cad/module/CADModule/model/common/interface'
import { BaseEntity } from './BaseEntity'

/**
 * 样条曲线实体，支持 FIT 与 CV 两种构造模式。
 */
export class SplineEntity extends BaseEntity {
  /** 阶数，CAD 默认为 3 */
  degree: number = 3
  /** 节点矢量（Knot Vector） */
  knots!: number[]
  /** 控制点列表，为核心存储项 */
  controlPoints!: IPoint[]
  /** 权重列表，存在时表示 NURBS */
  weights?: number[]

  /** 创建方法：FIT 使用拟合点，CV 使用控制点 */
  method: 'FIT' | 'CV' = 'FIT'
  /** 原始拟合点，仅在 method 为 FIT 时存在 */
  fitPoints?: IPoint[]

  /** 是否闭合 */
  isClosed: boolean = false
  /** 起点切向，仅 FIT 模式 */
  startTangent?: IPoint | undefined
  /** 终点切向，仅 FIT 模式 */
  endTangent?: IPoint | undefined

  protected readonly serializeKeys: string[] = [
    'degree',
    'knots',
    'controlPoints',
    'weights',
    'method',
    'fitPoints',
    'isClosed',
    'startTangent',
    'endTangent',
  ]

  constructor(data: Partial<SplineEntity>) {
    super(EntityType.Spline)
    Object.assign(this, data)
  }

  /**
   * 获取捕捉数据，FIT 模式返回拟合点，CV 模式返回控制点。
   *
   * @returns 仅包含端点的捕捉数据
   */
  getCaptureData() {
    const endPoints: IPoint[] = []
    if (this.method === 'FIT') {
      this.fitPoints?.forEach((point) => {
        endPoints.push({ x: point.x, y: point.y })
      })
    } else {
      this.controlPoints?.forEach((point) => {
        endPoints.push({ x: point.x, y: point.y })
      })
    }

    return { endPoints }
  }
}
